import { createAction, props } from '@ngrx/store';
import { ApiProgram } from '@app/programs/views/models/api-program';
import { ProgramError } from '@app/programs/views/services/programs-api-http.service';

const TAG = '[Programs]';

export const loadProgram = createAction(`${TAG} Load program`, props<{ id: number }>());
export const loadProgramSuccess = createAction(`${TAG} Load program success`, props<{ program: ApiProgram }>());
export const loadProgramFailure = createAction(`${TAG} Load program error`, props<{ error: ProgramError }>());

